/* eslint-disable react/no-array-index-key */
import React from "react";
import { Row, Col, Tabs, Divider } from "antd";

const formatString = (value) => {
  let tempString = value.replaceAll("_", " ");
  tempString = tempString
    .replaceAll("num", "jumlah")
    .replaceAll("jalan", "Alamat")
    .replaceAll("radius3km", "Radius 3 KM")
    .replaceAll("radius10km", "Radius 10 KM")
    .replaceAll("Num", "Jumlah");
  tempString = tempString
    .replaceAll("sdm", "SDM")
    .replaceAll("tps", "TPS")
    .replaceAll("blk", "BLK")
    .replaceAll("umkm", "UMKM")
    .replaceAll("bmt", "BMT")
    .replaceAll("smk", "SMK")
    .replaceAll("mck", "MCK");
  return tempString
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
    .join(" ");
};

const formatValueString = (value) => {
  if (typeof value === "object" && value != null) {
    const tempStr = `${value.map((e) => ` ${e}`)}`;
    return tempStr.substring(0, tempStr.length);
  }
  return value;
};

export default {
  renderDetail: (data) => {
    const profilKeys = [
      "pesantren",
      "tahun_berdiri",
      "jalan",
      "provinsi",
      "no_telp_pesantren",
      "email_pesantren",
      "website_pesantren",
      "jumlah_cabang",
      "pola_kepemimpinan",
      "afiliasi",
      "asosiasi",
    ];

    const pendidikanKeys = [
      "total_pendidik",
      "total_pendidik_pesantren",
      "total_pendidik_sma",
      "total_pendidik_d3",
      "total_pendidik_s1",
      "total_pendidik_s2",
      "total_pendidik_s3",
      "total_santri_mukim",
      "total_santri_nonmukim",
      "sarana_num_masjid",
      "sarana_luas_masjid",
      "sarana_kapasitas_masjid",
      "sarana_num_asrama_putra",
      "sarana_luas_asrama_putra",
      "sarana_kapasitas_asrama_putra",
      "sarana_num_asrama_putri",
      "sarana_luas_asrama_putri",
      "sarana_kapasitas_asrama_putri",
      "sarana_num_kelas_putra",
      "sarana_luas_kelas_putra",
      "sarana_kapasitas_kelas_putra",
      "sarana_num_kelas_putri",
      "sarana_luas_kelas_putri",
      "sarana_kapasitas_kelas_putri",
      "sarana_num_ruang_pemimpin",
      "sarana_luas_ruang_pemimpin",
      "sarana_kapasitas_ruang_pemimpin",
      "sarana_num_ruang_guru",
      "sarana_luas_ruang_guru",
      "sarana_kapasitas_ruang_guru",
      "sarana_num_pengurus_putra",
      "sarana_luas_pengurus_putra",
      "sarana_kapasitas_pengurus_putra",
      "sarana_num_pengurus_putri",
      "sarana_luas_pengurus_putri",
      "sarana_kapasitas_pengurus_putri",
      "sarana_num_perpustakaan",
      "sarana_luas_perpustakaan",
      "sarana_kapasitas_perpustakaan",
      "sarana_num_aula",
      "sarana_luas_aula",
      "sarana_kapasitas_aula",
      "sarana_num_laboratorium_bahasa",
      "sarana_luas_laboratorium_bahasa",
      "sarana_kapasitas_laboratorium_bahasa",
      "sarana_num_laboratorium_komputer",
      "sarana_luas_laboratorium_komputer",
      "sarana_kapasitas_laboratorium_komputer",
      "sarana_num_lapangan",
      "sarana_luas_lapangan",
      "sarana_kapasitas_lapangan",
      "sarana_num_mck",
      "sarana_luas_mck",
      "sarana_kapasitas_mck",
      "sarana_num_blk",
      "sarana_luas_blk",
      "sarana_kapasitas_blk",
      "sarana_num_tps",
      "sarana_luas_tps",
      "sarana_kapasitas_tps",
      "sarana_num_ruang_makan",
      "sarana_luas_ruang_makan",
      "sarana_kapasitas_ruang_makan",
      "sarana_num_penginapan_wali",
      "sarana_luas_penginapan_wali",
      "sarana_kapasitas_penginapan_wali",
      "sarana_num_karantina",
      "sarana_luas_karantina",
      "sarana_kapasitas_karantina",
      "pendidikan_formal",
      "pendidikan_nonformal",
      "rasio_sdm_per_santri",
      "sumber_daya_teknologi",
      "sarana_num_lahan",
      "sarana_luas_lahan",
      "sarana_kapasitas_lahan",
    ];

    const dakwahKeys = ["kegiatan_dakwah"];

    const ekonomiKeys = [
      "jenis_usaha",
      "lokasi_lahan_dekat_pemukiman",
      "lokasi_lahan_dekat_jalanraya",
      "lokasi_lahan_mudah_diakses",
      "lokasi_lahan_dekat_pasar",
      "lokasi_lahan_dekat_transportasi",
      "lokasi_lahan_dekat_umkm",
      "lokasi_lahan_subur",
      "lokasi_lahan_dekat_wisata",
      "lokasi_lahan_dekat_mataair",
      "pemenuh_beras",
      "pemenuh_air_galon",
      "pemenuh_air_gelas",
      "pemenuh_ayam",
      "pemenuh_ikan",
      "pemenuh_tahu",
      "pemenuh_tempe",
      "pemenuh_seragam",
      "pemenuh_sarung",
      "pemenuh_kopiah",
      "pemenuh_sandal",
      "pemenuh_sabun_mandi",
      "pemenuh_sikat_gigi",
      "pemenuh_pasta_gigi",
      "pemenuh_kitab_alquran",
      "pemenuh_kitab_kuning",
      "pemenuh_pulpen_pensil",
      "pemenuh_tas",
      "pemenuh_buku_tulis",
      "pemenuh_laundry",
      "pemenuh_jasa_kebersihan",
      "pemenuh_internet",
      "pemenuh_jasa_it",
      "pemenuh_jasa_telepon",
      "ada_kopontren",
      "guru_kelola_kopontren",
      "karyawan_kelola_kopontren",
      "santri_kelola_kopontren",
      "ortuwali_kelola_kopontren",
      "masyarakat_mitra_kelola_kopontren",
      "masyarakat_umum_kelola_kopontren",
      "kopontren_anggota_koperasi_sekunder",
      "nama_koperasi_sekunder",
      "kopontren_anggota_asosiasi",
      "nama_asosiasi_kopontren",
      "pesantren_memiliki_bank",
      "pesantren_memiliki_bmt",
      "pesantren_memiliki_bank_wakaf",
      "pesantren_memiliki_baitul_maal",
      "pesantren_memiliki_lembaga_keuangan_lainnya",
      "memiliki_sertifikasi_halal_usaha",
      "melakukan_usaha_ecommerce",
      "warga_pemilik_usaha_pesantren",
      "warga_karyawan_usaha_pesantren",
      "warga_pemasok_usaha_pesantren",
      "warga_konsumen_usaha_pesantren",
      "warga_mitra_usaha_pesantren",
      "warga_kerjasama_kelola_lahan_pesantren",
      "warga_kerjasama_kelola_lahan_warga",
      "kendala_bahan_baku",
      "kendala_mendapat_tenaga_kerja",
      "kendala_skill_tenaga_kerja",
      "kendala_sarana_usaha",
      "kendala_alam",
      "kendala_keawetan_produk",
      "kendala_legalitas",
      "kendala_sertifikat_halal",
      "kendala_penjualan",
      "kendala_tembus_pasar_digital",
      "kendala_selera_konsumen",
      "kendala_pembiayaan",
      "rencana_pengembangan_usaha",
      "mitra_lembaga_keuangan",
      "mitra_lembaga_keuangan_dahulu",
      "mitra_kementrian",
      "mitra_kementrian_lainnya",
      "sektor_usaha_dekat_pesantren",
      "komoditas_dekat_pesantren",
      "produksi_dekat_pesantren",
      "ada_industri_besar_dekat_pesantren",
      "nama_industri_besar_dekat_pesantren",
      "profesi_masyarakat_dekat_pesantren",
      "num_umkm_radius3km",
      "umkm_dekat_pesantren",
      "umkm_bertransaksi_digital",
      "ada_pesantren_lain_radius10km",
      "num_pesantren_lain_radius10km",
      "ada_smk_mak_radius10km",
      "ada_kerjasama_pesantren_smk",
      "bentuk_kerjasama_pesantren_smk",
      "ada_perguruan_tinggi_radius10km",
      "transport_angkot_dekat_pesantren",
      "transport_ojol_dekat_pesantren",
      "transport_taksi_dekat_pesantren",
      "transport_dekat_pesantren_lainnya",
      "jarak_pesantren_bis_antarkota",
      "jarak_pesantren_stasiun_kereta",
      "jarak_pesantren_bandara",
      "jarak_pesantren_pelabuhan",
      "kualitas_sarana_air_bersih",
      "kualitas_sarana_listrik",
      "kualitas_sarana_telepon",
      "kualitas_sarana_internet",
      "kualitas_sarana_pos",
      "kualitas_sarana_pasar",
      "kualitas_sarana_pertokoan",
      "tempat_menabung_masyarakat_pesantren",
      "tempat_meminjam_masyarakat_pesantren",
    ];

    return (
      <div>
        <Tabs defaultActiveKey="profil" size="large">
          <Tabs.TabPane tab="Profil" key="profil">
            {profilKeys.map((e, idx) => {
              return (
                <div key={idx}>
                  <Row>
                    <Col span={8} className="text-default text-bold">
                      {formatString(e)}
                    </Col>
                    <Col
                      className="text-default"
                      span={16}
                      style={{
                        wordWrap: "normal",
                      }}
                    >
                      {formatValueString(data[e])}
                    </Col>
                  </Row>
                  <Divider />
                </div>
              );
            })}
          </Tabs.TabPane>
          <Tabs.TabPane tab="Pendidikan" key="pendidikan">
            {pendidikanKeys.map((e, idx) => {
              return (
                <div key={idx}>
                  <Row key={idx}>
                    <Col span={8} className="text-default text-bold">
                      {formatString(e)}
                    </Col>
                    <Col
                      className="text-default"
                      span={16}
                      style={{
                        wordWrap: "normal",
                      }}
                    >
                      {formatValueString(data[e])}
                    </Col>
                  </Row>
                  <Divider />
                </div>
              );
            })}
          </Tabs.TabPane>
          <Tabs.TabPane tab="Dakwah" key="dakwah">
            {dakwahKeys.map((e, idx) => {
              return (
                <div key={idx}>
                  <Row key={idx}>
                    <Col span={8} className="text-default text-bold">
                      {formatString(e)}
                    </Col>
                    <Col
                      className="text-default"
                      span={16}
                      style={{
                        wordWrap: "normal",
                      }}
                    >
                      {formatValueString(data[e])}
                    </Col>
                  </Row>
                  <Divider />
                </div>
              );
            })}
          </Tabs.TabPane>
          <Tabs.TabPane tab="Ekonomi" key="ekonomi">
            {ekonomiKeys.map((e, idx) => {
              return (
                <div key={idx}>
                  <Row key={idx}>
                    <Col span={8} className="text-default text-bold">
                      {formatString(e)}
                    </Col>
                    <Col
                      className="text-default"
                      span={16}
                      style={{
                        wordWrap: "normal",
                      }}
                    >
                      {formatValueString(data[e])}
                    </Col>
                  </Row>
                  <Divider />
                </div>
              );
            })}
          </Tabs.TabPane>
        </Tabs>
      </div>
    );
  },
};
